import React, { useState, useEffect } from 'react';
import { trans } from '@spotahome/soyuz/client';
import { MediaQuery } from '@spotahome/ui-library';
import PropTypes from 'prop-types';

import HeroContainer from '@components/HeroContainer';
import HeaderContainer from '@components/HeaderContainer';
import TrustPilotRating from '@components/TrustPilotRating';

import CitySelector from '../../../../common/components/CitySelector';

import './Hero.scss';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const HeroTenant = ({ cityList }) => {
  const [isDark, setIsDark] = useState(true);
  useEffect(() => {
    setIsDark(isMobileScreen() || isPhabletScreen() || isTabletScreen());
  }, []);
  return (
    <section>
      <HeroContainer>
        <div className="hero__header-wrapper">
          <HeaderContainer
            color={isDark ? 'dark' : 'light'}
            tracking="ga-home-tenant"
            links={{ listYourProperty: {}, tenantLandingPage: null }}
          />
        </div>
        <div className="hero-tenant-wrapper">
          <div className="hero-tenant-container">
            <div className="hero-tenant__info">
              <div className="hero-tenant__info-content">
                <h1 className="hero-tenant__info-title">
                  {trans('home.tenant.hero.title')}
                </h1>
                <p className="hero-tenant__info-subtitle">
                  {trans('home.tenant.hero.subtitle')}
                </p>
                <CitySelector
                  cities={cityList}
                  className="hero-tenant__city-selector"
                />
                <TrustPilotRating
                  starsColor="#32B496"
                  className="hero-tenant__info-rating"
                />
              </div>
            </div>
            <div className="hero-tenant__image" />
          </div>
        </div>
      </HeroContainer>
    </section>
  );
};

HeroTenant.propTypes = {
  cityList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default HeroTenant;
